import React from "react";
import AppRoutes from "../routes";
import Footer from "../components/commalax_v2/footer";
import Header from "../components/commalax_v2/header";
import HomePage from "../pages/commalax_v2/home_page";
const CommalaxV2Template = () => {
  return (
    <div>
      <Header />
      <AppRoutes homePage={HomePage} />
      <Footer />
    </div>
  );
};

export default CommalaxV2Template;
